export default {
  install (Vue) {
    if (!document.getElementById('accept-js')) {
      const url = process.env.VUE_APP_AUTHORIZENET_ACCEPTJS_URL
      const script = document.createElement('script')
      script.id = 'accept-js'
      script.src = url
      script.charset = 'utf-8'
      script.async = true

      script.onload = () => {
        console.log('Authorize.Net Accept.js loaded')
      }

      document.head.appendChild(script)
    } else {
      console.log('Authorize.Net Accept.js loaded already')
    }

    Vue.prototype.$accept = {
      dispatch (secureData, callback) {
        if (!window.Accept) {
          console.error('Accept.js not yet loaded.')
          return
        }
        window.Accept.dispatchData(secureData, callback)
      }
    }
  }
}
